import React from 'react';
import PropTypes from 'prop-types'; // Optional: For prop type validation

const Field = React.memo(({ config, value, onChange, error }) => (
  <div className="form-group">
    <input
      type={config.type}
      name={config.name}
      placeholder={config.placeholder}
      value={value}
      onChange={onChange}
      required={config.required}
      aria-describedby={`${config.name}Error`}
      className={error ? 'input-error' : ''}
    />
    {error && (
      <span id={`${config.name}Error`} className="error-message">
        {error}
      </span>
    )}
  </div>
));

// Optional: Define PropTypes for better developer experience
Field.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default Field;